import { useTaskOption, TaskOption } from '../TaskOptions';

import { useTaskModal } from './context.taskModal';

interface Config {
  closeModalOnAction?: boolean;
}

export function useModalsTaskOption(option: TaskOption, { closeModalOnAction }: Config = {}) {
  const { task, close } = useTaskModal();

  const config = useTaskOption(option, task.id);

  return {
    ...config,
    action: () => {
      if (closeModalOnAction) close();
      config.action();
    },
  };
}
